export default class ScrollTop {
	static init() {
		Array.prototype.forEach.call(document.querySelectorAll('.scroll-top'), el => {
			window.addEventListener('scroll', (e) => {
				el.classList[window.scrollY > window.innerHeight ? 'add' : 'remove']('visible');
			});
		});
	}
}
